// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/main-feature/mainSlideshow.js';
import seoBlock from './js/widgets/seo-sec_slideshow/seoBlock.js';
import secondarySlideshow from './js/widgets/seo-sec_slideshow/secondarySlideshow.js';
import mainCards from './js/widgets/mainCards.js';
import videoWidget from './js/widgets/videoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import rotatingCorpMembers from './js/widgets/rotatingCorpMembers.js';
import blocksSection from './js/widgets/blocks-section/blocksComponent.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    seoBlock();
    secondarySlideshow();
    mainCards();

    $(globalThis).on('load', function () {
      videoWidget();
    });

    scrollerSponsors();
    rotatingCorpMembers();
    blocksSection();
  }
});
